exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.4); }\n  .modal > * {\n    position: absolute;\n    background-color: #ddd;\n    top: 10%;\n    left: 50%;\n    transform: translate(-50%, 0%);\n    max-width: 50%;\n    padding: 60px;\n    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2); }\n    @media (max-width: 768px) {\n      .modal > * {\n        max-width: 80%; } }\n    @media (max-width: 425px) {\n      .modal > * {\n        max-width: 100%; } }\n  .modal input {\n    border-bottom: solid 1px white; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/ui/Modal/Modal.scss
// module id = 129
// module chunks = 0